import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=79a96312&scoped=true&"
import script from "./ViewJob.vue?vue&type=script&lang=js&"
export * from "./ViewJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a96312",
  null
  
)

export default component.exports